import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import BookingIndex from "../../../components/SidetabPages/Booking/BookingIndex";

const Booking = () => {
  return (
    <>
      <AnnouncementBar />
      <BookingIndex />
    </>
  );
};
export default Booking;
